import { createContext } from "react";

const SocketsContext = createContext({
  modelUpdated: [],
  callbackFunction: () => {},
});

export default SocketsContext;
